export const COL_USERS = 'users';
export const COL_ANALYTICS_USERS = 'analytics_users';
export const COL_PROSPECT = 'prospects';
export const COL_CONVERSATION = 'conversation';
export const COL_TENANT = 'tenant';
export const COL_CONTENT_SUMMARY = 'content_summary';
export const COL_API_KEYS = 'api_keys';
export const PUBLIC_URL = 'https://botbakery.app';
